import * as React from "react";
import {VeBoxCard} from "../../../../components/card/VeBoxCard";
import {Display} from "../../../../components/Display";

import "./Section.scss";

interface SectionProps {
    title?: string;
    className?: string;
    legacySection?: boolean
}

export const Section: React.FC<SectionProps> = (props) => {
    return (
        <>
            <Display isVisible={!props.legacySection}>
                <VeBoxCard className={"Section"}>
                    <Display isVisible={props.title}>
                        <VeBoxCard.Header title={props.title} titleClassName={"lowercase capitalize"}/>
                    </Display>
                    <VeBoxCard.Body style={{padding: 0}}>
                        {props.children}
                    </VeBoxCard.Body>
                </VeBoxCard>
            </Display>
            <Display isVisible={props.legacySection}>
                {props.children}
            </Display>
        </>
    );
};
